export const RESPONSABLES_PATH = '/admin/store-admins';
export const COMPTABLES_PATH = '/admin/comptables';
export const FACTURATION_PATH = '/admin/facturation';
export const DEPOTS_PATH = '/admin/depots-en-compte';
export const BANQUE_PATH = '/admin/banque';
export const MANDATS_PATH = '/admin/mandats';
export const INHERITED_GESTIONNAIRE_PATHS = [RESPONSABLES_PATH, COMPTABLES_PATH, FACTURATION_PATH, DEPOTS_PATH, BANQUE_PATH, MANDATS_PATH];

// Inherited access works for existing accounts/sessions without a data migration.
const POINTAGES_LEGACY = ['/admin/attendance-validation', '/admin/history', '/admin/regularizations', '/admin/overtime-requests'];
export const canAccessGestionnairePath = (user, path) => {
  if (!user?.is_gestionnaire) return true;
  if (path === '/admin/pointages') return POINTAGES_LEGACY.some(p => (user.allowed_tabs || []).includes(p) || INHERITED_GESTIONNAIRE_PATHS.includes(p));
  return path === '/admin/dashboard' || INHERITED_GESTIONNAIRE_PATHS.includes(path)
    || (user.allowed_tabs || []).includes(path)
    || (path === '/admin/stores' && (user.allowed_tabs || []).includes('/admin/my-stores'));
};